import { CommonModule } from '@angular/common';
import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { FormErrorMessageDirective } from '../../../directives/form-error-message.directive';
@Component({
  selector: 'app-checkbox',
  imports: [CommonModule, CheckboxModule, FormsModule, FormErrorMessageDirective],
  templateUrl: './checkbox.html',
  styleUrl: './checkbox.scss',
})
export class Checkbox implements ControlValueAccessor {
  @Input() label = '';
  @Input() options: any[] = [];
  @Input() optionLabel = 'label';
  @Input() optionValue = 'value';
  @Input() disabled = false;
  @Input() layout: 'vertical' | 'horizontal' = 'vertical';
  @Input() checkboxCustomClass: string = '';
  @Input() submitted: boolean = false;
  value: any[] = [];

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  private onChangeFn: (value: any) => void = () => {};
  private onTouchedFn: () => void = () => {};

  writeValue(value: any): void {
    this.value = value ?? [];
  }
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onToggle(event: any, option: any) {
    const optionVal = option[this.optionValue];
    if (event.checked) {
      this.value = [...this.value, optionVal];
    } else {
      this.value = this.value.filter((v) => v !== optionVal);
    }
    this.onChangeFn(this.value);
    this.onTouchedFn();
  }

  isChecked(option: any): boolean {
    return this.value?.includes(option[this.optionValue]);
  }
}
